import styled from 'styled-components'

import { minmedia } from '../../styles/media-queries'

export const MiniContainer = styled.div`
  max-width: 100%;
  width: 345px;
  margin: 2rem auto;

  ${minmedia.large`
    width: ${props => (props.micro ? '500px' : '840px')};
    margin-top: 3rem;
    margin-bottom: 3rem;
  `};
`

export const Title = styled.h1`
  display: none;

  ${minmedia.xmlarge`
    display: block;
    font-weight: 400;
    margin-bottom: 1.5rem;
    font-size: 36px;
  `};
`



// WEBPACK FOOTER //
// ./src/views/Settings/styles.js